import { useEffect, useState } from 'react'
import axios from 'axios'
import Accordion from 'react-bootstrap/Accordion'
import Alert from 'react-bootstrap/Alert'
import Badge from 'react-bootstrap/Badge'
import Card from 'react-bootstrap/Card'
import Spinner from 'react-bootstrap/Spinner'
import { useSelector } from 'react-redux'

const formatDateTime = value =>
  value
    ? new Intl.DateTimeFormat('fi-FI', {
        dateStyle: 'short',
        timeStyle: 'medium',
      }).format(new Date(value))
    : '-'

const formatDuration = value => {
  const milliseconds = Number(value)
  if (!Number.isFinite(milliseconds)) return '-'
  return `${(milliseconds / 1000).toFixed(1)} s`
}

const getIssueLabel = report =>
  String(report?.jobName || '').startsWith('teamSpirit')
    ? 'Ohitetut tai epäonnistuneet ottelut'
    : 'Epäonnistuneet kohteet'

const AdminReports = () => {
  const user = useSelector(state => state.user)
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let mounted = true

    const loadReports = async () => {
      try {
        const response = await axios.get(
          `/login/reports/${encodeURIComponent(user.oauth_token)}`
        )
        if (mounted) setReports(Array.isArray(response.data) ? response.data : [])
      } catch (requestError) {
        if (mounted) {
          setError(
            requestError.response?.data?.error || 'Raporttien lataus epäonnistui'
          )
        }
      } finally {
        if (mounted) setLoading(false)
      }
    }

    if (user?.oauth_token) loadReports()
    else setLoading(false)

    return () => {
      mounted = false
    }
  }, [user?.oauth_token])

  if (loading) {
    return <Spinner animation="border" size="sm" className="mt-3" />
  }

  return (
    <Card className="mt-3 mb-4">
      <Card.Body>
        <h3 className="mb-3">Päivitysraportit</h3>
        {error ? <Alert variant="danger">{error}</Alert> : null}
        {!error && reports.length === 0 ? <div>Ei päivitysraportteja.</div> : null}
        <Accordion>
          {reports.map(report => {
            const succeeded = report.status === 'completed'
            return (
              <Accordion.Item eventKey={String(report._id)} key={String(report._id)}>
                <Accordion.Header>
                  <span className="me-2">{report.jobName}</span>
                  <Badge bg={succeeded ? 'success' : 'danger'} className="me-2">
                    {succeeded ? 'Onnistui' : 'Epäonnistui'}
                  </Badge>
                  <span>{formatDateTime(report.startedAt)}</span>
                </Accordion.Header>
                <Accordion.Body>
                  <div><strong>Käynnistys:</strong> {report.source === 'manual' ? 'Painike' : 'Cron'}</div>
                  <div><strong>Kesto:</strong> {formatDuration(report.durationMs)}</div>
                  <div><strong>{getIssueLabel(report)}:</strong> {report.failedUsersCount || 0}</div>
                  {report.fatalError ? <Alert variant="danger" className="mt-3 mb-0">{report.fatalError}</Alert> : null}
                  {report.failedUsers?.length ? (
                    <pre className="mt-3 mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {JSON.stringify(report.failedUsers, null, 2)}
                    </pre>
                  ) : null}
                  {report.details ? (
                    <pre className="mt-3 mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {JSON.stringify(report.details, null, 2)}
                    </pre>
                  ) : null}
                </Accordion.Body>
              </Accordion.Item>
            )
          })}
        </Accordion>
      </Card.Body>
    </Card>
  )
}

export default AdminReports
